import React, { Component } from 'react';
import './App.css';
import MainContainer from './Components/MainContainer/MainContainer.js'

class App extends Component {
  render() {
    return (
      <MainContainer/>
    );
  }
}

export default App;
